module.exports = __webpack_public_path__ + "img/hsg-product-three.bf3b3249.png";